/**
 * API paths that never receive an Authorization header and never trigger a
 * refresh-on-401 (security.md §4 whitelist). Single source shared by the
 * transport layer (ADR-015 — no scattered endpoint strings).
 */
export const ANONYMOUS_API_PATHS: readonly string[] = [
  '/auth/login',
  '/auth/refresh',
  '/auth/mfa/verify',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/activate',
  '/public/quotes/',
];

export function isAnonymousApiPath(url: string): boolean {
  return ANONYMOUS_API_PATHS.some((path) => url.includes(path));
}

/** Public quote links are fully credentialless; unlike refresh/logout they do not need cookies. */
export function isPublicQuoteApiPath(url: string): boolean {
  return url.includes('/public/quotes/');
}
